<template>
  <div class="breadcrumb-bar">
    <button @click="goBack" class="back-btn">
      <AppIcon name="arrow-left" />
    </button>
    <div class="breadcrumb-path">
      <span
        class="breadcrumb-parent"
        :class="{ 'breadcrumb-parent--link': backRoute }"
        @click="backRoute && $router.push(backRoute)"
      >{{ parentName }}</span>
      <span class="breadcrumb-divider">/</span>
      <span class="breadcrumb-current">{{ currentName }}</span>
    </div>
    <div v-if="$slots.actions" class="breadcrumb-actions">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BreadcrumbBar',
  
  props: {
    parentName: {
      type: String,
      required: true
    },
    currentName: {
      type: String,
      required: true
    },
    backRoute: {
      type: String,
      default: null
    }
  },
  
  methods: {
    goBack() {
      if (window.history.length > 2) {
        this.$router.back()
      } else if (this.backRoute) {
        this.$router.push(this.backRoute)
      } else {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style scoped>
.breadcrumb-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 32px;
  background: var(--white);
  border-bottom: 0.7px solid var(--gray-200);
}

.back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: none;
  border: 1px solid var(--gray-300);
  border-radius: 6px;
  color: var(--gray-600);
  cursor: pointer;
  transition: all 0.15s ease;
}

.back-btn:hover {
  background: var(--gray-50);
  border-color: var(--gray-400);
  color: var(--gray-800);
}

.breadcrumb-path {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  flex: 1;
}

.breadcrumb-parent {
  color: var(--gray-500);
  font-weight: 500;
}

.breadcrumb-parent--link {
  cursor: pointer;
}

.breadcrumb-divider {
  color: var(--gray-400);
}

.breadcrumb-current {
  color: var(--gray-900);
  font-weight: 600;
}

.breadcrumb-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
